export class ListSourceAwsOrganizationalUnitsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnits",
            "baseName": "organizationalUnits",
            "type": "Array<SourceAwsOrganizationalUnit>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSourceAwsOrganizationalUnitsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
